import Action, {GET, POST_FORM,POST} from "../common/Action";

export const getSalesReportAction = new Action('GET_SALES', POST, 'order/sales');

export const getSalesReport = (eventId) => getSalesReportAction.callApi(({eventId: Number(eventId)}));